module.exports = __webpack_public_path__ + "static/media/unpin.cabf75d8.svg";